import React, { FC } from 'react';
import { ReactComponent as Trash } from '../../../assets/Common/Trash.svg';

export const DeleteIcon: FC = () => <Trash />;
